import mixpanel from "mixpanel-browser";

mixpanel.init(process.env.REACT_APP_ANALYTICS_SOURCE_TOKEN, {
  autocapture: false,
  record_sessions_percent: 0,
  disable_session_recording: true,
  track_pageview: false
});

export default mixpanel;